import { withLayout } from 'layouts';
import WorkshopEnrolmentComplete from './workshop-enrolment-complete.component';

export default withLayout(WorkshopEnrolmentComplete);
